import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from 'react-router';
import { Link } from "react-router-dom";
import * as types from "../../constants/actionTypes";
import DataComponent from "../common/DataComponent";
import AmbulatoryCareRoomStatus from "../care/AmbulatoryCareRoomStatus";
import * as d from "../../reducers/domainReducer";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";

import Cookies from "cookies-js";

import UserMobileModal from "../care/UserMobileModal";
const Interactive_InApp_Tutorial = 'InteractiveInAppTutorial';  //cookie name for Interactive In App Site Tour

/**
 * Container component for the dashboard page.
 * 
 */
class Dashboard extends DataComponent {

    constructor(props) {
        super(props);
        //console.log("Dashboard constructor...");
        this.shouldLoadData = this.shouldLoadData.bind(this);
        this.onDepartmentFilterChange = this.onDepartmentFilterChange.bind(this);

        //debugger;
        this.state = {
            showInteractiveTutorial: window.location.search === "?whatsnew=1",
            departmentListFilter: ""
        };

    }

    componentDidCatch(ex, info) {
        let json = { error: ex, componentStack: info };
        //logUI("MBHWeb.UI.Dashboard.ComponentDidCatch", new Date(), Tools.getURLPath(), JSON.stringify(json));
        logUI("MBHWeb.UI.MainErrorBoundary.ComponentDidCatch", new Date(), Tools.getURLPath(), JSON.stringify(ex), JSON.stringify(info));
    }

    componentDidMount() {
        if (super.componentDidMount) { super.componentDidMount(); }
        logUI("MBHWeb.Dashboard.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    shouldLoadData() {
        return this.props.isLoggedIn;
    }

    allWordsContained(stringToSearch, stringToSearchFor) {
        var allMatched = true;
        var sMain = stringToSearch.toLowerCase();
        var sLook = stringToSearchFor.toLowerCase();
        var sPeices = sLook.split(" ");
        for (var i = 0; i < sPeices.length; i++) {
            if (sMain.indexOf(sPeices[i]) === -1) {
                allMatched = false;
                break;
            }
        }
        return allMatched;
    }

    onDepartmentFilterChange(e) {
        if (e) {
            const newValue = e.target.value;
            this.setState({ departmentListFilter: newValue });

            //let fields = this.state.fields;
            //fields[target.name] = e.target.value;
            //this.setState({ fields });
            //if (this.inputsChanged) {
            //    this.inputsChanged();
            //}
            //window.componentChanged = true;
        }
    }

    render() {
        const {
            serverData, lanID, NPI, epicID, loadingProviderAppointments, loadingSameDayCareAppointments,
            isProviderAppointmentsFailure, isProviderAppointmentsSuccess, isSDCAppointmentsFailure, isSDCAppointmentsSuccess,
            employeeType, userSettings
        } = this.props;

        const failedToLoadProviderAppts = !loadingProviderAppointments && !isProviderAppointmentsSuccess && isProviderAppointmentsFailure;
        const failedToLoadSDCAppts = !loadingSameDayCareAppointments && !isSDCAppointmentsSuccess && isSDCAppointmentsFailure;
        const apptTryAgainBannerClass = (failedToLoadProviderAppts || failedToLoadSDCAppts) ? " appt-tryagain-banner" : "";          //Adding class in case of appointments try again banner

        //var filteredDepts = departmentList ? departmentList.filter(d => this.allWordsContained( d.n + ' ' + d.e + ' ' + d.i, departmentListFilter)) : null;

        const pathname = (typeof window !== "undefined") ? window.location.href.toLowerCase() : "";

        try {

            return (
                <div className={"container-fluid body-content dashboard-container" + apptTryAgainBannerClass}>
                    <div className="row">
                        <div className="col-12">
                            {serverData && serverData.environment !== "PROD" &&
                                <div>
                                    LAN ID:  {lanID} <br />
                                    NPI:  {NPI} <br />
                                    Epic ID:  {epicID} <br />
                                    Type: {employeeType} <br />

                                    {/*<input type="text"
                                        className="form-control-had-a-terrible-looking-style"
                                        name="inputDepartmentFilter"
                                        id="inputDepartmentFilter"
                                        onChange={e => this.onDepartmentFilterChange(e)} /><br />*/}
                                </div>
                            }
                            {/*!filteredDepts && <MiniSpinner />}
                            {filteredDepts && filteredDepts.map((item, key) => <React.Fragment key={item.i}><span>{item.i} ||| {item.n} ||| {item.e}</span><br /></React.Fragment>
                            )*/}
                            <AmbulatoryCareRoomStatus />
                            {userSettings && userSettings.showModal && <UserMobileModal loginEvent />}
                        </div>
                    </div>
                </div>
            );

        }
        catch (ex) {
            console.error(ex);
            return <div>Exception rendering!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! {ex}</div>;
        }
    }
}

const mapStateToProps = (state) => {
    return {
        isLoggedIn: state.domain.li,
        serverData: state.session.serverData,
        lanID: state.domain.lan,
        NPI: state.domain.npi,
        epicID: state.domain.eid,
        departmentList: state.epic.departmentList,
        loadingProviderAppointments: state.epic.loadingProviderAppointments,
        loadingSameDayCareAppointments: state.epic.loadingSameDayCareAppointments,
        isProviderAppointmentsSuccess: state.epic.isProviderAppointmentsSuccess,
        isProviderAppointmentsFailure: state.epic.isProviderAppointmentsFailure,
        isSDCAppointmentsSuccess: state.epic.isSDCAppointmentsSuccess,
        isSDCAppointmentsFailure: state.epic.isSDCAppointmentsFailure,
        employeeType: state.domain.et,
        userSettings: state.sso.userSettings,
    };
};

const DashboardComp = withRouter(connect(mapStateToProps, null)(Dashboard));

export default DashboardComp;